import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductXSpecialGroup } from "src/models/Products/SpecialGroup.models";

interface ProductXSpecialGroupState {
  productXSpecialGroups: IProductXSpecialGroup[];
  productXSpecialGroupToEdit: IProductXSpecialGroup | null;
}

const initialState: ProductXSpecialGroupState = {
  productXSpecialGroups: [],
  productXSpecialGroupToEdit: null,
};

const productXSpecialGroupSlice = createSlice({
  name: "ProductXSpecialGroup",
  initialState,
  reducers: {
    setProductXSpecialGroupList: (
      state,
      action: PayloadAction<IProductXSpecialGroup[]>
    ) => {
      state.productXSpecialGroups = action.payload;
    },
    concatListProductXSpecialGroup: (
      state: ProductXSpecialGroupState,
      action: PayloadAction<IProductXSpecialGroup[]>
    ) => {
      state.productXSpecialGroups = [
        ...state.productXSpecialGroups.concat(action.payload),
      ];
    },
    setProductXSpecialGroupToEdit: (
      state,
      action: PayloadAction<IProductXSpecialGroup | null>
    ) => {
      state.productXSpecialGroupToEdit = action.payload;
    },
    addProductXSpecialGroup: (
      state,
      action: PayloadAction<IProductXSpecialGroup>
    ) => {
      state.productXSpecialGroups.push(action.payload);
    },
    updateProductXSpecialGroup: (
      state,
      action: PayloadAction<IProductXSpecialGroup>
    ) => {
      let itemIndex = state.productXSpecialGroups.findIndex(
        item =>
          item.productXSpecialGroupId === action.payload.productXSpecialGroupId
      );
      if (itemIndex !== -1)
        state.productXSpecialGroups[itemIndex] = action.payload;
    },
    deleteProductXSpecialGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.productXSpecialGroups.filter(
        item => item.productXSpecialGroupId !== action.payload
      );
      state.productXSpecialGroups = newArray;
    },
  },
});

export const {
  setProductXSpecialGroupList,
  concatListProductXSpecialGroup,
  setProductXSpecialGroupToEdit,
  addProductXSpecialGroup,
  updateProductXSpecialGroup,
  deleteProductXSpecialGroup,
} = productXSpecialGroupSlice.actions;

export default productXSpecialGroupSlice.reducer;
